import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { useTheme } from '@mui/material/styles';

export default function NavCard() {
  const theme = useTheme();
  
   
return (
    <Card
      sx={{
        bgcolor: theme.palette.grey[100],
        color: theme.palette.text.primary,
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        p: 1,
        cursor: 'pointer',
        '&:hover': { bgcolor: theme.palette.grey[100], opacity: 0.85 }
      }}
      elevation={3}
    >
    

   
    </Card>
  );
}
